import { pathExists } from '@wix/cli-fs';
import { CliErrorCode, CliError } from '@wix/cli-error';
import type { WixAstroConfig } from '@wix/cli-astro-definitions';
import { readBuildMetadata } from './build-metadata.js';

export async function assertBuildOutputExists(
  projectFolder: string,
  config: WixAstroConfig
) {
  const buildMetadata = await readBuildMetadata(projectFolder, config);

  const targets = [
    ...(buildMetadata.metaDataSource === 'WIX_CONFIG'
      ? []
      : [buildMetadata.appManifestPath]),
    ...(buildMetadata.clientDir ? [buildMetadata.clientDir] : []),
    ...(buildMetadata.serverDir ? [buildMetadata.serverDir] : []),
  ];

  for (const target of targets) {
    if (!(await pathExists(target))) {
      throw new CliError({
        code: CliErrorCode.BuildOutputMissing({
          reason: `"${target}" doesn't exist.`,
        }),
        cause: null,
      });
    }
  }
}
